import React, { useState } from 'react';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import ArcaPdfStudioLayout from '../../components/arca/ArcaPdfStudioLayout';
import { appendUploadFiles, isPdfFile } from '../../components/arca/uploadItemUtils';
import { getToken } from '../../api/client';
import API_CONFIG from '../../config/api';

function baixarBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export default function ArcaPdfPdfParaWordPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const file = items[0]?.file || null;

  const handleFilesAdd = (files) => {
    setError('');
    const n = appendUploadFiles(files, setItems, { multiple: false, filter: isPdfFile });
    if (!n) setError('Selecione um arquivo PDF.');
  };

  const handleConvert = async () => {
    setError('');
    if (!file) {
      setError('Envie um PDF.');
      return;
    }
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append('file', file, file.name);
      const token = getToken();
      const res = await fetch(`${API_CONFIG.BACKEND_URL}/api/arca/pdf/convert/pdf-to-word`, {
        method: 'POST',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        body: fd,
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.error || `Erro na conversão (${res.status}).`);
      }
      const blob = await res.blob();
      const disposition = res.headers.get('Content-Disposition') || '';
      const match = disposition.match(/filename\*?=(?:UTF-8''|")?([^";]+)/i);
      const filename = match
        ? decodeURIComponent(match[1].replace(/"/g, ''))
        : `documento-${Date.now()}.docx`;
      baixarBlob(blob, filename);
    } catch (e) {
      console.error('[ArcaPdfPdfParaWord]', e);
      setError(e.message || 'Erro ao converter.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <ArcaPdfStudioLayout
      title="PDF para Word"
      info="Gera um .docx editável (LibreOffice — melhor esforço). PDFs complexos/escaneados podem perder formatação. Clique no thumbnail · ↻ para girar."
      limits={
        <>
          Limite: <strong>50 MB</strong> · 1 arquivo. Opcional: <code>LIBREOFFICE_PATH</code>.
        </>
      }
      error={error}
      onClearError={() => setError('')}
      onRotateError={setError}
      items={items}
      setItems={setItems}
      loading={loading}
      enableSortAlpha={false}
      dropzone={{
        accept: 'application/pdf,.pdf',
        multiple: false,
        maxSizeMb: 50,
        onFilesAdd: handleFilesAdd,
        label: 'Arraste um PDF ou clique para selecionar',
        hint: 'Máximo 50MB',
      }}
      actionLabel="Converter e baixar Word"
      actionLoadingLabel="Convertendo…"
      actionStartIcon={<DescriptionOutlinedIcon />}
      onAction={handleConvert}
      actionDisabled={!file}
    />
  );
}
